export default "__VITE_ASSET__xDWHR1fr__"